let worker = null;
let workerState = 'uninitialized';
let pendingRequests = new Map();
let requestCounter = 0;

// Reusable canvas for frame capture (created once)
let captureCanvas = null;
let captureCtx = null;

function getCaptureCanvas() {
  if (!captureCanvas) {
    captureCanvas = document.createElement('canvas');
    captureCanvas.width = 320;
    captureCanvas.height = 240;
    captureCtx = captureCanvas.getContext('2d', { willReadFrequently: true });
  }
  return { canvas: captureCanvas, ctx: captureCtx };
}

export const faceDetectionService = {

  initialize() {
    if (worker || workerState === 'loading' || workerState === 'ready') return;
    workerState = 'loading';

    worker = new Worker(
      new URL('../workers/faceDetectionWorker.js', import.meta.url),
      { type: 'module' }
    );

    worker.onmessage = (e) => {
      const { type, state, requestId, faceCount, faces, error } = e.data;

      if (type === 'status') {
        workerState = state;
        console.log(`[FaceDetection] Worker state: ${state}`, error || '');
      }

      if (type === 'result') {
        const resolve = pendingRequests.get(requestId);
        if (resolve) {
          resolve({ faceCount, faces: faces || [], state });
          pendingRequests.delete(requestId);
        }
      }
    };

    worker.onerror = (err) => {
      console.error('[FaceDetection] Worker error:', err);
      workerState = 'failed';
    };

    // Tell worker to initialize MediaPipe
    worker.postMessage({ type: 'init' });
  },

  getState: () => workerState,
  isReady: () => workerState === 'ready',
  hasFailed: () => workerState === 'failed',

  async detectFaces(videoEl, _timestampMs) {
    if (workerState !== 'ready' || !worker) {
      return { faceCount: -1, faces: [], state: workerState };
    }

    if (!videoEl?.videoWidth || !videoEl?.videoHeight) {
      return { faceCount: -1, faces: [], state: 'video_not_ready' };
    }

    try {
      const { canvas, ctx } = getCaptureCanvas();
      canvas.width = videoEl.videoWidth;
      canvas.height = videoEl.videoHeight;
      ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

      const requestId = ++requestCounter;

      return new Promise((resolve) => {
        pendingRequests.set(requestId, resolve);

        setTimeout(() => {
          if (pendingRequests.has(requestId)) {
            pendingRequests.delete(requestId);
            resolve({ faceCount: -1, faces: [], state: 'timeout' });
          }
        }, 3000);

        worker.postMessage({
          type: 'detect',
          requestId,
          imageData: imageData.data.buffer,
          width: canvas.width,
          height: canvas.height,
        }, [imageData.data.buffer]);
      });

    } catch (err) {
      console.error('[FaceDetection] Frame capture error:', err);
      return { faceCount: -1, faces: [], state: 'error' };
    }
  },

  destroy() {
    if (worker) {
      worker.postMessage({ type: 'destroy' });
      worker.terminate();
      worker = null;
    }
    workerState = 'uninitialized';
    pendingRequests.clear();
    requestCounter = 0;
    captureCanvas = null;
    captureCtx = null;
    console.log('[FaceDetection] Destroyed');
  }
};

export default faceDetectionService;
